<template>
  <div
    v-if="options"
    class="gap-4"
    :class="[
      wrapperClass ||
        'grid @csm/main:grid-cols-2 not-supports-cq:sm:grid-cols-2 @cmd/main:grid-cols-3 not-supports-cq:md:grid-cols-3 w-full MM-task-group',
    ]"
  >
    <AccountFeatureWrapper
      v-for="(option, index) in options"
      :key="`option-${index}`"
      allow-if-unspecified
      :feature="taskKeyFeatureMap[option.key] || ''"
      :action-text="$t('words.Upgrade')"
      class="rounded-md"
      @action="upgrade"
    >
      <div
        role="button"
        :data-key="option.key"
        class="gap-2 w-full p-4 hover:bg-gray-100 dark:hover:bg-surface-700/80 rounded-lg duration-300"
        :class="{
          'opacity-40 cursor-not-allowed': isDisabled(option),
          'border border-surface-100 dark:border-surface-700/5': forceItemBorder,
          [itemClass || '']: !!itemClass,
        }"
        :data-gtm-action="analyticsEvents.TASKS.select_task_type"
        v-bind="itemProps"
        @click="handleTaskClick(option)"
      >
        <div class="flex items-center justify-between gap-4">
          <div
            class="h-12 w-12 p-3 mb-2 bg-primary rounded-md shrink-0 text-white"
            :class="iconClass"
          >
            <DynamicIcon :key="option.key" :item="option as any" />
          </div>

          <p v-if="isDisabled(option)" class="text-sm text-green-600">
            {{ $t("comingSoon") }}
          </p>
        </div>

        <div>
          <p>{{ i18n.fromTaskConfig("title", option) }}</p>
          <p class="text-sm opacity-70">
            {{ i18n.fromTaskConfig("description", option) }}
          </p>
        </div>
        <ChevronRightIcon class="h-5 w-5 opacity-70 ml-auto shrink-0 hidden" />
      </div>
    </AccountFeatureWrapper>
  </div>
</template>

<script setup lang="ts" generic="T extends Record<string, any> = any">
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import DynamicIcon from "../shared/DynamicIcon.vue";
import AccountFeatureWrapper from "../shared/AccountFeatureWrapper.vue";
import type { HTMLAttributes, ReservedProps } from "vue";
const props = defineProps<{
  options: T[];
  handleClickExternally?: boolean;
  wrapperClass?: string;
  forceItemBorder?: boolean;
  itemClass?: string;
  iconClass?: string;
  itemProps?: Record<string, string | number | boolean> & HTMLAttributes & ReservedProps;
}>();

const emit = defineEmits<{
  upgrade: [];
  taskClick: [T];
}>();

const i18n = withI18nHelpers();
const route = useRoute();
const router = useRouter();

function isDisabled(option: any) {
  if (option.enabled === false) {
    return true;
  }
  return false;
}

function upgrade() {
  emit("upgrade");
}

const nextRoute = (option: any) => {
  const formattedRoute = getTaskRouteLink(option);
  const scheduled = route.query.scheduled ? { scheduled: true } : {};
  return { ...formattedRoute, query: { ...formattedRoute.query, ...scheduled } };
};

function handleTaskClick(option: any) {
  if (isDisabled(option)) {
    return;
  }
  if (props.handleClickExternally) {
    emit("taskClick", option);
    return;
  }
  router.push(nextRoute(option));
}
</script>
